export class CreateClassificationPolicyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupPolicyResourceSelector",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "ClassificationPolicySchedule",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "scheduleTimezone",
            "baseName": "scheduleTimezone",
            "type": "ScheduleTimezone",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateClassificationPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
